<template>
<div class="container-fluid" >

 <div class="card border-success">
  <modal-spinner :key="reset" v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
  <div class="card-header text-white bg-primary">
    <h4><i style="color:yellow" class="fas fa-camera mr-2" aria-hidden="true"></i>SHOOTING CHECK LIST</h4>
  </div> 

 <div  class="card-body"> 
  

<div class="row">

<div v-if="items.length==0" class="col-md-3"> 

  <div  class="card border-info" >
  <div class="card-header  bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="movementSearch" v-on:submit.prevent="submit()">
    <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>

    <brand-list v-bind:props="brand" @update="setBrandId"></brand-list>      
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
    <category-select v-bind:props="categoryGroup"  @update="setCategoryId"></category-select>
    
    
    <div class="card-footer bg-transparent border-info"> 
      <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
        <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
          <i class="far fa-play-circle mr-2"></i>
          ESEGUI
          <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
        </button>         
    </div>

  </form>
  

  </div>
</div>
</div>


<div v-else class="col">

  <button v-if="items.length>0"  @click="items=[],brandItems=[],stock=1,filterKey='',filterProduct=''" type="button"  class="btn btn-secondary mb-3">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    ANNULLA
  </button> 



<div class="row">
<div class="col-md-4">

<div class="brandList">

  <table class="table brand mb-0 table-hover pointer">
    <thead >
      <tr>
        <th></th>
        
        <th>BRAND</th>
        <th>TOTALE DA FOTOGRAFARE</th>
        <th>TOTALE FOTOGRAFATO</th>
        
        
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="doppio click Lista prodotti" @dblclick="setProducts(item.brand)"  :style="setColor(item)" v-for="(item, index) in filteredItems" :key="index">
      
       <td> {{item.index}} </td>
       <td> {{item.brand}} </td>
       <td> {{item.totalToDo}} </td>
       <td> {{item.totalDone}} </td>
       
                
      </tr> 

    </tbody>
        <tfoot>
        <tr>  
        <th></th>
        <th></th>
        <th>{{total_row.total1}}</th>
        <th>{{total_row.total2}}</th>
       
        </tr>
      
      </tfoot> 
  </table>
  


</div>
<div v-if="progress>0" class="progress">
    <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
      {{ progress }}%
    </div>
</div>
  

<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterKey">
</div>

<div class="col-md-8">


<div v-if="brandItems.length>0">
 
<div class="card border-info">
  <div class="card-header"><h4>LISTA PRODOTTI - <strong>{{brand.name}}</strong> 
  
  </h4></div>
  <div class="card-body">

  <div class="catalog mb-3">
  <ul class="list-unstyled pointer"  :style="{backgroundColor: item.selected==1 ? '#dbfedb':'white'}"  :class="`index-${index}`"  v-for="(item, index) in filteredProducts" :key='index'>
    <li class="media ">
      
      <img  v-for="n in item.images.length" :key="n"  @click="imgZoom(item.images[n-1])" v-bind:src="`${item.images[n-1]}`" :id="`${item.images[n-1]}`"    alt="" width="100" height="100"  class="align-self-center  rounded mr-3 mb-4">      
      
      <div @click="setSelection(index,$event)" class="media-body mt-2">
      
        <h5 class="mt-0 mb-1">
          <span :class="{dotRed:item.stock == 0}" class = "mr-3"></span>
          
          {{index+1}}  -  {{item.productId}} 
          <i v-if="item.updateItem" style="font-size: 25px; color:brown" class="fas fa-camera ml-4"></i>
        </h5>

        <h5 class="mt-0 mb-1">{{item.brand}} <strong> {{item.sku}} </strong>  {{item.category}} {{item.department}} </h5>

        <h4>
          {{item.color}} 
          <table class="table brandProducts table-sm table-bordered">
              <thead class="foo">
              <tr >
              <th v-for="(col,index) in cols[item.img]" :key="index">
                {{col}}
              </th>
              </tr>
              </thead>
            <tbody>
            <tr :style="{color: 'black' ,fontSize:  '14px' }"  v-for="(row, index) in rows[item.img]" :key="index">
            <td v-for="(col,index) in cols[item.img]" :key="index">
              {{row[col]}}
            </td>
            </tr>
            </tbody>
          </table>

          <div class="form-check">
           
            <input @click.stop="setShooting(index)" v-model="item.updateItem" class="form-check-input pointer" type="checkbox" :id="'defaultCheck1'">
            <label class="form-check-label" for="defaultCheck">
            Fotografato

          </label>
          </div>


          <!--<product-stock v-bind:cols="cols[item.img]" v-bind:rows="rows[item.img]"></product-stock>          -->
        </h4>
           
    </div>

 






  </li>
 
</ul>




</div>

<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterProduct">

<h4 class="float-left">Prodotti selezionati <strong>{{print}}</strong></h4>


<button :disabled="print==0" @click="printPDF()"  class="btn btn-success mt-3 mr-3 float-right">
          <i class="fas fa-file-pdf mr-2"></i>
          STAMPA LISTA
</button>   


</div>


</div>




</div>
</div>  




</div>




</div>



<img-zoom v-if="img" @close="closeImg()" v-bind:img='img'></img-zoom>

</div>


 

</div>
</div>


</div>




</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';



import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'


import imgZoom           from '@/components/common/ProductImg.vue'
import modalSpinner      from '@/components/common/ModalSpinner.vue'
import brandList         from '@/components/common/CompanyBrandSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import categorySelect    from '@/components/common/CategoryGroupingSelect_1.vue'


import axios             from 'axios'
import jsPDF             from 'jspdf';
import pushState         from '@/components/mixins/pushState'


export default {
  mixins : [pushState],
  components: {alertBox,seasonSelect,yearSelect,imgZoom,modalSpinner,brandList,departmentSelect,categorySelect},
  data() {
    return {

      brand           :
      {
        Id            : '',
        required      : false,
        name          : ''

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },
      categoryGroup   : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },
      modalSpinner : {spinner:false,show:false},
      filenames       : [],  
      products        : [],
      brandItems      : [],
      filterKey       : '',
      filterProduct   : '',
      total           : [],
    
    
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
    

      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
    
      items           : [], 
      img             : '',
      images          : [],
      cols            : [],
      rows            : [],
      progress        : 0,
      reset           : 0
      
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
    
   getProgress()
    {
      let p = this.progress
      return p + "%";
    },
    print : function()
    {
      let total = 0
      this.products.forEach(
        item => {
          if(item.selected==1)
          {
            total++
          }
        }
        
      )
      return total
    },
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     filteredProducts : function () 
      {
        var filterProducts = this.filterProduct && this.filterProduct.toLowerCase()
        var items = this.brandItems
        if (filterProducts) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterProducts) > -1
          })
        })
      }
        return items
     },
    total_row : function()
    {
      let total = {total1:0,total2:0,total3:0}
      this.filteredItems.forEach(item=>{
        total.total1 = total.total1 + parseInt(item.totalToDo)
        total.total2 = total.total2 + parseInt(item.totalDone)
        //total.total3 = total.total3 + parseInt(item.totalExcluded)

      })
      return total
    },
  
  },
  
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {
   if(this.company.Id == 26 || this.company.Id == 20 || this.company.Id == 32 || this.company.Id == 37)
   { 
    this.getShootingList()
    //this.getShootingList('foo')
   }
  },
  methods: {
    setShooting(index)
    {
      let productId = this.filteredProducts[index].productId
      let colorId = this.filteredProducts[index].colorId
      let updateItem = this.filteredProducts[index].updateItem ? 0:1 
      
      
      this.updateProductColorShooting(productId,colorId,updateItem)
    },
    setBrandId(brandId)
    {
      

      this.brand.Id = brandId
      

    },
    setCategoryId(categoryId)
    {      
      this.categoryGroup.Id = categoryId
    },  
    setDepartmentId(departmentId)
    {
      this.department.Id = departmentId
    },
    setModalSpinner(show,option)
      {
        this.modalSpinner.btn = ''
        if(option == 'Retry')
        {
          this.reset++
          this.getShootingList()
          return
        }
        
        this.modalSpinner.show = show
        

        
      },
    setColor(item)
    {
      if(item.totalDone == 0)
      {
        return {color:'black'}
      }
      if(item.totalToDo == item.totalDone)
      {
        return {color:'green',fontSize: '25px',fontStyle:'bold'}
      }
      if(item.totalDone>0)
      {
        return {color:'blue',fontSize: '20px',fontStyle:'bold'}
      }
    },

    setProducts(brand)
    { 
      

      this.img_spinner   = true
      this.filterProduct = ''
      this.brand.name    = brand
      this.brandItems    = []
      
      
      this.products.forEach(item=>{

        

        if(item.brand == brand)
        {
          this.brandItems.push(item)
        }
      })
      
      this.brandItems.forEach(item=>
      {
        item.images = [] 
        this.filenames.forEach(img=>{
          let index = img.indexOf("_") 
          if(item.img == img.substring(0,index))
          {
            item.images.push(item.url+img)
          }
                    
        })  
      })
      
      this.img_spinner = false
      this.setProductsSizeList()
      this.$nextTick(function () 
        {
          this.scrollToElement()
        })                
    },

    setProductsSizeList()
    {
      
      let arr_cols  = []
      let arr_rows  = []
      let cols      = []
      let row       = {}
      let data      = []
      //let index = 0
      //console.log(this.brandItems)
      this.brandItems.forEach(item =>
      {
       
        if(item.sizeList)
        {

        data = item.sizeList.split(',')
        cols = []
        row  = {}        
        data.forEach(col => {

          let tmp = col.split('=')  
          let size = tmp[0]
          let qty  = tmp[1]
         
          cols.push(size)
          row[size]= qty
        
        })
       
        arr_cols[item.img] = cols
        arr_rows[item.img] = []
        arr_rows[item.img].push(row)

        this.products.forEach(product =>
        {
          
          if(product.img == item.img)
          {
            product.cols = cols
            product.row = row
          }
          
        })




        }  

      })
      

      this.cols = arr_cols
      this.rows = arr_rows

      


    },

 
    getShootingList(files)
    {
        
         
         if(files)
         {
          this.modalSpinner.title   = 'Scan immagini step 2/2 in corso ...'
         }
         else
         {
          this.modalSpinner.title   = 'Scan immagini step 1/2 in corso ...'
         }
         this.modalSpinner.show    = true
         this.modalSpinner.spinner = true 
         
         let api = ''
         // CAPOSERIO
         if(this.company.Id == 26)
         {
            api = files  ?  'https://api-shooting.ey.r.appspot.com/files' : 'https://api-shooting.ey.r.appspot.com/'

            

         }
         
         
         // NEW LOOK
         if(this.company.Id == 20)
         {
           api = files  ?  'https://api-shooting-340316.lm.r.appspot.com/files' : 'https://api-shooting-340316.lm.r.appspot.com/'
         } 

         // VISTITA
         if(this.company.Id == 32)
         {
           api = files  ?  'https://shooting-360310.uc.r.appspot.com/files' : 'https://shooting-360310.uc.r.appspot.com/'
         }
         // GESS
         if(this.company.Id == 37)
         {
           api = files  ?  'https://gifted-vigil-368816.uc.r.appspot.com/files' : 'https://gifted-vigil-368816.uc.r.appspot.com/'
         }

         axios({
              url    : api,
              method : "get",
              
              }).then(res => {
                //this.spinner = false
                //this.modalSpinner.show = false 
               
                if(!files)  
                {
                  
                 
                  this.images = res.data
                  
                  this.reset++
                  this.getShootingList('foo')

                }
                else
                {
                  this.filenames            = res.data
                  this.modalSpinner.btn     = ''
                  this.modalSpinner.spinner = false            
                  this.modalSpinner.msg     = 'Scan completato.'
                  this.reset++

                }


              }).catch(err => {
                this.modalSpinner.btn = 'Retry'
                this.modalSpinner.spinner = false            
                this.modalSpinner.msg = err
                //this.spinner = false
                console.log(err)

              })
    },
    

    scrollToElement(options) {
      const el = this.$el.getElementsByClassName('index-0')[0];
      
      if (el) {
        el.scrollIntoView(options);
      }
    },
    setAltImg(event) 
    { 
        event.target.src = require("@/assets/no_img.jpg")
    },         
 
    imgZoom(img)
    {
        this.img = img
    },
    closeImg()
    {
        this.img = ''
    },
    setSelection(index,e)
    {
      
      

      if(this.filteredProducts[index].stock > 0)
      {
        this.filteredProducts[index].selected = this.filteredProducts[index].selected == 0 ? 1:0
      }
          
    },

    fmt1(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },

  
    setSeasonId(seasonId)
    {   
        
        this.season.Id = seasonId
    },  
    setYear(year)
    {
        this.season_year.year = year
    },
    submit() 
    {
      this.getData()
      
    },  
    
    
    async updateProductColorShooting(productId,colorId,updateItem)
    {
      this.modalSpinner.btn = ''
      this.modalSpinner.title   = 'Aggiornamento corso ...'
      
      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true 

      let sp = {'sp' : 'spUpdateProductColorShooting'}

      var data  = {
        'productId'      : productId,
        'colorId'        : colorId,
        'update'         : updateItem
        
      }
      
      var json  = Object.assign(data, sp)   
      await api.post(json).then(async res => {
         
         if(res.status==200)
           {
            this.modalSpinner.show   = false
           }
           else if (res.status==500)
           {
             
               
             this.modalSpinner.spinner   = false
             this.modalSpinner.title = 'ATTENZIONE'
             this.modalSpinner.msg =  res.data
             
             
           }
         
         else
         {

             this.modalSpinner.spinner   = false
             this.modalSpinner.title = 'ATTENZIONE'
             this.modalSpinner.msg =  res

                       

         }
     }).catch(err=>{
       
         this.modalSpinner.spinner   = false
         this.modalSpinner.title = 'ATTENZIONE'
         this.modalSpinner.msg =  err.message
  
      }).finally(() => {
         this.modalSpinner.spinner   = false
        
        })
         
      },
    
    async getData() {
      
      this.modalSpinner.btn = ''
      this.modalSpinner.title   = 'Ricerca prodotti in corso ...'
      
      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true 
      this.items  = []
        
      this.msg.title = ''
      var sp = {'sp' : 'spShootingCheckList'}
      
      var data  = {

        'companyId'      : this.company.Id,
        'seasonId'       : this.season.Id,
        'season_year'    : this.season_year.year,
        'departmentId'   : this.department.Id,
        'categoryId'     : this.categoryGroup.Id,
        'brand'          : this.brand.Id

      }
     
      var json  = Object.assign(data, sp)      
      //this.spinner = true

      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0]
              
              if(this.items.length==0)
              {
                
                this.modalSpinner.spinner   = false
                this.modalSpinner.title = 'ATTENZIONE'
                this.modalSpinner.msg   = 'Prodotti non trovati.'
                return  
                
                //this.msg.type  = 1

              }  
              this.modalSpinner.show   = false
              this.products = res.data.recordsets[1]

              
              function wait(ms) 
              {
                return new Promise(resolve => {
                setTimeout(() => { resolve('') },ms);
                })
              }
      
              let r     = 0                
              let j
              for (j = 0; j < this.items.length; j++) {
                let item = this.items[j]
                
                r++  
                this.progress = Math.round(r / this.items.length * 100)
                await wait(0) 
                                
                let i               
                for (i = 0; i < this.products.length; i++) 
                {
                  let row = this.products[i]  
                  if(this.images.includes(row.img) && row.brand == item.brand)
                  {
                    item.totalDone = item.totalDone + 1
                  }
                  
                }
              }
              
              this.progress = 0
              
                
              

            }
            else if (res.status==500)
            {
              
                
              this.modalSpinner.spinner   = false
              this.modalSpinner.title = 'ATTENZIONE'
              this.modalSpinner.msg =  res.data
              
              
            }
          
          else
          {

              this.modalSpinner.spinner   = false
              this.modalSpinner.title = 'ATTENZIONE'
              this.modalSpinner.msg =  res

                        

          }
      }).catch(err=>{
        
          this.modalSpinner.spinner   = false
          this.modalSpinner.title = 'ATTENZIONE'
          this.modalSpinner.msg =  err.message
   


            

      }).finally(() => {
          this.modalSpinner.spinner   = false
          //this.modalSpinner.show = false

        });
      

    },

    printPDF()
    {
      let rows = 17
    
      let items = this.products.filter(item => item.selected == 1) 
      
    
      
      const doc = new jsPDF()

      this.spinner2 = true  
      var page = 1
      
      var pages = parseInt(items.length / rows) == items.length / rows ? parseInt(items.length / rows) : parseInt(items.length / rows) + 1
      
      var row_index    = 1
      var page_index   = 1
      var init_row     = 31
      var row          = init_row
      var row_header   = row -5
      var col          = 10
      var col1         = 20
      var col2         = 50
      var col3         = 110
      var col4         = 140
      var col5         = 180
      

      var header = function()
      {
        var d = new Date();
        var n = d.toLocaleString();
        doc.setFontSize(12)
        doc.text('SHOOTING LIST  ' + n ,  105, 10, null, null, "center");
        
        doc.setFont("helvetica","bold");
      
        doc.setFontSize(10)
      
        doc.text('BRAND', col1,row_header);
        doc.text('CODICE', col2,row_header);
        doc.text('CATEGORIA', col3, row_header);
        doc.text('COLORE', col4, row_header);
        doc.text('REPARTO', col5, row_header);
                
        doc.setFont("helvetica","normal");

      }
      var footer = function()
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      
      header()

      footer()

      console.log(items)
    
      items.forEach(item=>{
        
        /*
        if(item.row_type == 1)
        {
          total += Number(item.qty)
        }
        */
        
        
        
       
        doc.setFontSize(8)
       
       

       doc.text(row_index.toString(), col, row);
       doc.text(item.brand.toString().substr(0,15), col1, row);
       doc.text(item.sku.toString().substr(0,30), col2, row);
       doc.setFont("helvetica","normal"); 
       doc.text(item.category.toString().substr(0,50), col3, row);
       doc.text(item.color.toString().substr(0,20) , col4, row);
       
       doc.text(item.department.toString().substr(0,25), col5, row);
       row = row + 5
       let n = col
       let w = 10  
       if(!item.cols)
       {
        console.log(item)
       }

       item.cols.forEach(size => {
        doc.rect(n -1, row -3, w, 4);
        doc.text(size.toString().substr(0,10) , n, row);  
        n= n + w
       })
       n = col 
       for (const key in item.row) {
         doc.text(item.row[key].toString().substr(0,10) , n, row + 4);  
         n= n + w 
         
        } 
       

       row = row + 5

       
        if(page_index == rows && row_index < items.length)
        {
          page++  
          doc.addPage("a4");
          header()
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })
        doc.setFontSize(10)
        
      

      
      let fileName = 'CheckList_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      
    },
  
  },
  
};
</script>
<style scoped>


.brandList {
position: relative;
height: 400px;
overflow: auto;
}
.brandItems {
position: relative;
height: 500px;
overflow: auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}


.brand tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.brandProducts thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 14px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

 .table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 24px;
    background   : whitesmoke;
    color        : darkgreen;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 } 



.table-wrapper-scroll-y {
display: block;
}




h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}


div.catalog {
 
  height: 500px;
  _width: 200px;
  overflow-y: scroll;
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}


</style>